import styles from "./style.module.scss";
import Yakisoba from "src/assets/activity/yakisoba/02.jpg";
import { Link } from "react-router-dom";

export const ExperienceSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h2>
          Experience<span>-体験-</span>
        </h2>
        <div className={styles.imageBox}>
          <img src={Yakisoba} alt="yakisoba" />
          <p>Cooking</p>
        </div>

        <h3>買い物から調理まで！元祖石巻焼そばづくり。</h3>
        <p className={styles.description}>
          ご当地のスーパーマーケットで地元の新鮮な食材を買い出し、ヴィレッジのキッチンで一緒に石巻名物「元祖石巻焼そば」を作ります。石巻ならではの食材と出会い、自分たちで作ることで石巻の食文化を五感で楽しめます。ホテルではできない「地元の当たり前」を最も感じられる体験です。
        </p>

        <Link to="/activity#yakisoba" className={styles.link}>
          more
        </Link>
      </div>
    </section>
  );
};
